export const faq = {
    pathToFaq: 'boussole',
};
